import * as types from "./atividade.actionTypes";

export default {
  setSagaAtividade: (data) => ({
    type: types.SET_SAGA_ATIVIDADE,
    payload: data,
  }),
  setAtividade: (data) => ({
    type: types.SET_ATIVIDADE,
    payload: data,
  }),
  addSagaAtividade: (data) => ({
    type: types.ADD_SAGA_ATIVIDADE,
    payload: data,
  }),
  addAtividade: (data) => ({
    type: types.ADD_ATIVIDADE,
    payload: data,
  }),
  deleteSagaAtividade: (data) => ({
    type: types.DELETE_SAGA_ATIVIDADE,
    payload: data,
  }),
  deleteAtividade: (data) => ({
    type: types.DELETE_ATIVIDADE,
    payload: data,
  }),
  clearGridAtividade: () => ({
    type: types.CLEAR_GRID_ATIVIDADE,
  }),
  sagaAtividadeRemoveByCnae: (data) => ({
    type: types.SAGA_ATIVIDADE_REMOVER_BY_CNAE,
    payload: data,
  }),
  reducerAtividadeRemoveByCnae: (data) => ({
    type: types.REDUCER_ATIVIDADE_REMOVER_BY_CNAE,
    payload: data,
  }),
  mainSagaAtividade: (data) => ({
    type: types.MAIN_SAGA_ATIVIDADE,
    payload: data,
  }),
  mainAtividade: (data) => ({
    type: types.MAIN_ATIVIDADE,
    payload: data,
  }),
  onChange: (data) => ({
    type: types.ON_CHANGE_ATIVIDADE,
    payload: data,
  }),
  addListaAtividade: data => ({
    type: types.ADD_LISTA_ATIVIDADE,
    payload: data,
  })
};
